import { ACERTO_PRIME_V2_VARIANTES, FEATURE_FLAGS } from '@/constants/featureFlags';
import { sessionService } from '@/services';

/**
 * Gate da experiência visual do Acerto Prime na Home:
 * dívida Prime destacada em "Recomendada para você" e priorizada no topo da listagem. Mesma flag
 * usada por `DividaPrimeOrdenacaoService`. Verdadeiro para as variantes de tratamento
 * `prime_padrao` e `prime_destaque` de `feat_acerto_prime_v2`; falso para `control`/flag ausente.
 */
export function isPrimeFlowEnabled(): boolean {
  const variante = sessionService.getFeatureFlagValue(FEATURE_FLAGS.ACERTO_PRIME_V2);
  return variante === ACERTO_PRIME_V2_VARIANTES.PRIME_PADRAO || variante === ACERTO_PRIME_V2_VARIANTES.PRIME_DESTAQUE;
}

/**
 * Gate específico da variante `prime_destaque` de `feat_acerto_prime_v2`: agrupamento das demais
 * dívidas em accordion + destaque do credor Prime no header global (a variante `prime_padrao`
 * mantém a lista simples de outras dívidas e não escreve na store do header).
 */
export function isPrimeDestaqueEnabled(): boolean {
  return sessionService.getFeatureFlagValue(FEATURE_FLAGS.ACERTO_PRIME_V2) === ACERTO_PRIME_V2_VARIANTES.PRIME_DESTAQUE;
}
